import { createSlice } from '@reduxjs/toolkit';
import {
    ultimoRiego,
} from '../actions/ultimoRiego';


export const UltimoRiegoReducerNodo = createSlice({
    name: 'ultimoRiego',
    initialState: {
        homeSort: {
            sortby: "_id",
            order: "desc",
            limit: 4,
            skip: 0
        },
        loading: false,
        sensores: [],
        current: null
    },
    reducers: {
    },
    extraReducers: (builder) => {
        builder
            // GET ARTICLE
            .addCase(ultimoRiego.pending, (state) => { state.loading = true })
            .addCase(ultimoRiego.fulfilled, (state, action) => {
                state.loading = false;
                state.current = action.payload
            })
            .addCase(ultimoRiego.rejected, (state) => { state.loading = false })
    }
})

export default UltimoRiegoReducerNodo.reducer;
